import React from 'react';
import styles from './style.module.scss';
import ZeroGptLogo from './assets/ZeroGPT.svg';
import { ReactComponent as GptZeroLogo } from './assets/GPTZero.svg';
// import { ReactComponent as SaplingLogo } from './assets/Sapling.svg';
// import CopyLeaksLogo from './assets/CopyLeaks.svg';
import { ReactComponent as WinstonLogo } from '../TextDetectionResult/assets/Winston.svg';
import OriginalityLogo from './assets/Originality.svg';
import { useTranslation } from 'react-i18next';

export const CheckedByLogos: React.FC = () => {
    const { t } = useTranslation();
    
    return (
        <div className={styles.checkedByContainer}>
            <span className={styles.checkedByText}>{t('verified.by')}</span>
            <div className={styles.logos}>
                <img src={ZeroGptLogo} alt="ZeroGPT" style={{height: '22px', width: 'auto', objectFit: 'contain'}} />
                <GptZeroLogo />
                {/* <SaplingLogo /> */}
                {/* <img src={CopyLeaksLogo} alt="Copyleaks" style={{height: '22px', width: 'auto', objectFit: 'contain'}} /> */}
                <WinstonLogo />
                <img src={OriginalityLogo} alt="Originality.ai" className={styles.originalityLogo} />
            </div>
        </div>
    );
}; 